<template>
  <div class="container fluid pt-1 dmbs-content">
  <!-- <pre>
  {{ eventosOrdenados[0] }} {{  provincias }}
  </pre> -->
    <h2 class="page-header">{{$t(eventosPagina.filtro.nombre)}}</h2>
    <div
      :key="eventosPagina.pagina"
      class="jumbotron no_space"
      v-scroll="scroll"
    >
      <div class="container infinito">
        <hr>
        <div
          v-for="(item, v) in eventosScroll"
          :key="v"
          class="col-md-4 col-sm-6 col-xs-12"
        >

          <router-link
            v-if="item"
            :to="`/${$i18n.locale}/detalle/${item.cmsID}/${item.Recinto[0].Id}`"
            class="vacio"
          >

            <!-- <img
              :src="item.cms.poster"
              class="img-responsive sombreado"
            > -->
            <v-img
              v-if="miImagen(item)"
              class="imagen-ficha elevation-5"
              :src="miImagen(item)"
              :aspect-ratio="ratios[defaultImageSize]"
            >
              <v-layout
                slot="placeholder"
                fill-height
                align-center
                justify-center
                ma-0
              >
                <v-progress-circular
                  indeterminate
                  :color="colorDestacado"
                ></v-progress-circular>
              </v-layout>
            </v-img>
            <v-img
              v-else-if="item.cms.poster"
              class="imagen-ficha elevation-5"
              :src="item.cms.poster"
              :aspect-ratio="ratios[defaultImageSize]"
            >
              <v-layout
                slot="placeholder"
                fill-height
                align-center
                justify-center
                ma-0
              >
                <v-progress-circular
                  indeterminate
                  :color="colorDestacado"
                ></v-progress-circular>
              </v-layout>
            </v-img>
            <v-img
              v-else
              class="imagen-ficha elevation-5"
              :src="sinImagen"
              :aspect-ratio="ratios[defaultImageSize]"
            >

            </v-img>

            <div class="padding12">
              <p><b>{{item.Nombre}}</b></p>
              <p class="locate"><i class="fa fa-map-marker"></i><i>{{item.Recinto[0].Nombre}}</i><br>
              </p>
              <!-- <span class="pvp">{{item.cmsID}}</span> -->
  
              
              <span v-if="item.MinPrecioBase && $i18n.locale == 'eu'" class="pvp">{{ item.MinPrecioBase | formatNumber}} -{{$t('Desde')}}</span>
                <span v-else-if="item.MinPrecioBase" class="pvp">{{$t('Desde')}}: {{ item.MinPrecioBase | formatNumber}}</span>
            </div>
            <a
              class="btn  btn-comprar"
              role="button"
            >
              <i class="fa fa-shopping-cart"></i>&nbsp;{{$t('Comprar')}} </a>
            <a
              class="btn  btn-info"
              role="button"
            >
              <i class="fa fa-info-circle"></i>
            </a>
          </router-link>
          <br><br>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { globales } from "../../components/comunes";
import buscadorEventos from "../../components/Buscador";

export default {
  mixins: [globales],
  mounted() {
    // console.log("mounted eventos", this.eventosScroll, this.Hoy.ahora);
    this.cargarEventos();
  },
  components: {
    buscadorEventos,
  },
  watch: {
    $route(to, form) {
      this.cargarEventos();
      this.tipoTransicion = "fade";
    },
    cargarEventos(to, from) {
      // console.log('TRANSITION')
    },
    eventosOrdenados() {
      this.cargarEventos();
    },
  },
  data() {
    return {
      inicioScroll: 0,
      intervaloScroll: 24,
      finScroll: 24,
      scrolling: false,
      totalEventos: [],
      findePagina: false,
    };
  },
  computed: {
    eventosPagina() {
      const pagina = this.$route.params.id;
      const filtro = this.provincias.find(e => e.id == pagina);
      return {
        pagina,
        filtro,
      };
    },
    eventosScroll: {
      get() {
        return this.$store.state.eventosScroll;
      },
      set(valor) {
        this.$store.commit("setEventosScroll", valor);
      },
    },
    eventosOrdenados() {
      const eventos = this.$store.state.eventosWeb;
      return eventos.sort(
        (a, b) => parseFloat(a.FSesionMin) - parseFloat(b.FSesionMin)
      );
    },
  },
  methods: {
    scroll() {
      if (this.eventosScroll.length >= this.totalEventos.length) {
        // console.log('ya estan todos', this.findePagina)
        this.findePagina = true;
      }
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight;

      // console.log('v-scrooll', bottomOfWindow, this.findePagina)
      if (bottomOfWindow && !this.findePagina) {
        const inicio = this.eventosScroll.length;
        const fin = inicio + this.intervaloScroll;

        for (let o = inicio; o < fin; o++) {
          const element = this.totalEventos[o];
          // console.log(element.cms.titulo, 'evento', o, '/',this.totalEventos.length)
          this.eventosScroll.push(element);
        }
      }
      //  console.log('scriolll', window.innerHeight, document.documentElement.scrollTop, document.documentElement.offsetHeight )
    },
    vigencia(evento) {
      const ahora = this.Hoy.ahora;
      const vigente = evento < ahora;
      // -- console.log(evento.Nombre, "vigencia", vigente);

      return vigente;
    },
    cargarEventos() {
      // console.log('cargar EVENOTS', this.eventosWeb.length)
      var eventos = [];
      const pagina = this.$route.params.id;
      const filtro = this.provincias.find(e => e.id == pagina);
      const eventosOrdenados = this.eventosOrdenados;
      const ahora = this.Hoy.ahora;

      if (filtro.elemento == "00") {
        this.totalEventos = eventosOrdenados.filter(e => {
          if (
            e.Provincia[0].Id == "22" ||
            e.Provincia[0].Id == "11" ||
            e.Provincia[0].Id == "13"
          ) {
            return false;
          }
          return true;
        });

        // console.log('elemento', filtro.elemento)
      } else {
        // console.log('Todos los eventos web', this.eventosOrdenados)
        this.totalEventos = eventosOrdenados.filter(
          f => f.Provincia[0].Id == filtro.elemento
        );
      }

      const fin = this.finScroll;
      const inicio = this.inicioScroll;
      for (let o = inicio; o < fin; o++) {
        const element = this.totalEventos[o];
        eventos.push(element);
      }

      this.eventosScroll = this.totalEventos;
    },
  },
};
</script>
